export default __webpack_public_path__ + "static/1695-809a8296c8337b28a2331545ff33c5b3.gif";